// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Form$MakerDs from "maker-ds/src/Form.bs.mjs";
import * as Alert$MakerDs from "maker-ds/src/Alert.bs.mjs";
import * as Badge$MakerDs from "maker-ds/src/Badge.bs.mjs";
import * as Date$FeedSync from "./Date.bs.mjs";
import * as Query$MakerDs from "maker-ds/src/Query.bs.mjs";
import * as Table$MakerDs from "maker-ds/src/Table.bs.mjs";
import * as Button$MakerDs from "maker-ds/src/Button.bs.mjs";
import * as Layout$FeedSync from "./Layout.bs.mjs";
import * as ButtonV2$MakerDs from "maker-ds/src/ButtonV2.bs.mjs";
import * as Location$FeedSync from "./Location.bs.mjs";
import * as API_Result$MakerDs from "maker-ds/src/api/API_Result.bs.mjs";
import * as ClientAPI$FeedSync from "./ClientAPI.bs.mjs";
import * as ErrorPage$FeedSync from "./ErrorPage.bs.mjs";

function MonitoringPage$Show(Props) {
  var settings = Props.settings;
  var snapshots = Props.snapshots;
  var limitOpt = Props.limit;
  var mutate = Props.mutate;
  var limit = limitOpt !== undefined ? limitOpt : 100;
  var snapshots$1 = Belt_Array.slice(snapshots, 0, limit);
  var match = React.useState(function () {
        return snapshots$1;
      });
  var setPreviousSnapshots = match[1];
  var previousSnapshots = match[0];
  var match$1 = React.useState(function () {
        return [];
      });
  var setChangedTrackers = match$1[1];
  var changedTrackers = match$1[0];
  var didTrackerChange = function (tracker) {
    var currentTracker = Belt_Array.getBy(snapshots$1, (function (item) {
            return Caml_obj.equal(item.id, tracker.id);
          }));
    var previousTracker = Belt_Array.getBy(previousSnapshots, (function (item) {
            return Caml_obj.equal(item.id, tracker.id);
          }));
    if (currentTracker !== undefined && previousTracker !== undefined) {
      return currentTracker.lastUpdatedAt !== previousTracker.lastUpdatedAt;
    } else {
      return false;
    }
  };
  var didSettingsChange = function (tracker) {
    var currentIndex = Belt_Array.getIndexBy(snapshots, (function (item) {
            return Caml_obj.equal(item.id, tracker.id);
          }));
    var currentTracker = JSON.stringify(Belt_Option.map(Belt_Option.flatMap(currentIndex, (function (param) {
                    return Belt_Array.get(snapshots, param);
                  })), (function (item) {
                return item.settings;
              })));
    var previousTracker = JSON.stringify(Belt_Option.map(Belt_Option.flatMap(currentIndex, (function (index) {
                    return Belt_Array.get(snapshots, index + 1 | 0);
                  })), (function (item) {
                return item.settings;
              })));
    return Caml_obj.notequal(currentTracker, previousTracker);
  };
  var timer = React.useRef(undefined);
  React.useEffect((function () {
          var changed = Belt_Array.map(Belt_Array.keep(snapshots$1, didTrackerChange), (function (tracker) {
                  return tracker.id;
                }));
          Curry._1(setChangedTrackers, (function (param) {
                  return changed;
                }));
          var timer$1 = timer.current;
          if (timer$1 !== undefined) {
            clearTimeout(Caml_option.valFromOption(timer$1));
          }
          timer.current = Caml_option.some(setTimeout((function (param) {
                      Curry._1(setChangedTrackers, (function (param) {
                              return [];
                            }));
                    }), 1000));
          Curry._1(setPreviousSnapshots, (function (param) {
                  return snapshots$1;
                }));
        }), [JSON.stringify(snapshots$1)]);
  var getRowClassName = function (tracker) {
    return "transition-colors duration-500 " + (
            Belt_Array.some(changedTrackers, (function (id) {
                    return Caml_obj.equal(id, tracker.id);
                  })) ? "bg-yellow-50" : "bg-white"
          );
  };
  var columns = [
    {
      title: "Start Time",
      renderTitle: (function (param) {
          return React.createElement("div", {
                      style: {
                        width: "200px"
                      }
                    }, "Start Time");
        }),
      align: /* Left */0,
      render: (function (tracker) {
          return React.createElement(React.Fragment, undefined, React.createElement("div", undefined, Date$FeedSync.formatDistanceToNow(new Date(tracker.startTime))), React.createElement("div", {
                          className: CSS$MakerDs.prefix("text-xs text-gray-400")
                        }, new Date(tracker.startTime).toLocaleString()), React.createElement("div", {
                          className: CSS$MakerDs.prefix("flex justify-start gap-1")
                        }, Caml_obj.equal(tracker._isLive, true) ? React.createElement("div", {
                                className: CSS$MakerDs.prefix("mt-1")
                              }, React.createElement(Badge$MakerDs.make, {
                                    text: "Current",
                                    color: /* Green */2
                                  })) : null, Belt_Option.mapWithDefault(tracker.rollbackTime, null, (function (rollbackTime) {
                                return React.createElement("div", {
                                            className: CSS$MakerDs.prefix("mt-1")
                                          }, React.createElement(Badge$MakerDs.make, {
                                                text: "Rollback to " + new Date(rollbackTime).toLocaleString() + "",
                                                color: /* Yellow */4
                                              }));
                              })), tracker.requiresApproval && !tracker.resume && Belt_Option.mapWithDefault(tracker.result, false, Belt_Result.isOk) ? React.createElement("div", {
                                className: CSS$MakerDs.prefix("mt-1")
                              }, React.createElement(Badge$MakerDs.make, {
                                    text: "Requires Approval",
                                    color: /* Red */3
                                  })) : null, didSettingsChange(tracker) && Belt_Option.isNone(tracker.rollbackTime) ? React.createElement("div", {
                                className: CSS$MakerDs.prefix("mt-1")
                              }, React.createElement(Badge$MakerDs.make, {
                                    text: "Settings Changed",
                                    color: /* Yellow */4
                                  })) : null));
        }),
      getClassName: undefined,
      getColSpan: undefined
    },
    {
      title: "Accepted Entries",
      renderTitle: undefined,
      align: /* Left */0,
      render: (function (tracker) {
          return tracker.validProductCount;
        }),
      getClassName: undefined,
      getColSpan: undefined
    },
    {
      title: "Rejected Entries",
      renderTitle: undefined,
      align: /* Left */0,
      render: (function (tracker) {
          return React.createElement(React.Fragment, undefined, tracker.invalidProductCount > 0 ? React.createElement("span", {
                            className: CSS$MakerDs.prefix("text-red-600")
                          }, tracker.invalidProductCount) : React.createElement("span", undefined, tracker.invalidProductCount), tracker.invalidProductCount > 0 ? React.createElement(ButtonV2$MakerDs.make, {
                            text: "View Errors",
                            size: /* Xs */0,
                            disabled: tracker.downloadedAndStaticCached === false || tracker.startTime < 1733574763653.0,
                            onClick: (function (param) {
                                Location$FeedSync.goTo(true, undefined, Caml_option.some(Js_dict.fromArray([[
                                                "search",
                                                "Rejected"
                                              ]])), undefined, [
                                      "data",
                                      tracker.startTime.toString()
                                    ]);
                              })
                          }) : null);
        }),
      getClassName: undefined,
      getColSpan: undefined
    },
    {
      title: "With Warnings",
      renderTitle: undefined,
      align: /* Left */0,
      render: (function (tracker) {
          return React.createElement(React.Fragment, undefined, tracker.productsWithWarnings > 0 ? React.createElement("span", {
                            className: CSS$MakerDs.prefix("text-red-600")
                          }, tracker.productsWithWarnings) : React.createElement("span", undefined, tracker.productsWithWarnings), tracker.productsWithWarnings > 0 ? React.createElement(ButtonV2$MakerDs.make, {
                            text: "View Warnings",
                            size: /* Xs */0,
                            disabled: tracker.downloadedAndStaticCached === false || tracker.startTime < 1733574763653.0,
                            onClick: (function (param) {
                                Location$FeedSync.goTo(true, undefined, Caml_option.some(Js_dict.fromArray([[
                                                "search",
                                                "Warning"
                                              ]])), undefined, [
                                      "data",
                                      tracker.startTime.toString()
                                    ]);
                              })
                          }) : null);
        }),
      getClassName: undefined,
      getColSpan: undefined
    },
    {
      title: "Status",
      renderTitle: undefined,
      align: /* Left */0,
      render: (function (tracker) {
          var viewButton = React.createElement(ButtonV2$MakerDs.make, {
                text: "View Data",
                size: /* Xs */0,
                disabled: tracker.downloadedAndStaticCached === false,
                onClick: (function (param) {
                    Location$FeedSync.goTo(undefined, undefined, undefined, undefined, [
                          "data",
                          tracker.startTime.toString()
                        ]);
                  })
              });
          var rollbackButton = Caml_obj.notequal(tracker._isLive, true) && Caml_obj.notequal(tracker._isLatest, true) && Belt_Option.mapWithDefault(tracker.result, false, Belt_Result.isOk) && Belt_Option.isNone(tracker.rollbackTime) ? React.createElement(ButtonV2$MakerDs.make, {
                  text: "Rollback",
                  variant: /* Secondary */1,
                  size: /* Xs */0,
                  outline: true,
                  onClickAsync: (function (param) {
                      return API_Result$MakerDs.Result.silentFailure(ClientAPI$FeedSync.rollback(tracker.startTime));
                    })
                }) : null;
          var deployButton = tracker.requiresApproval && Caml_obj.equal(tracker._isLatest, true) && Caml_obj.notequal(tracker._isLive, true) && tracker.resume === false && Belt_Option.mapWithDefault(tracker.result, false, Belt_Result.isOk) ? React.createElement(ButtonV2$MakerDs.make, {
                  text: "Approve & Deploy",
                  size: /* Xs */0,
                  onClickAsync: (function (param) {
                      return API_Result$MakerDs.Result.silentFailure(ClientAPI$FeedSync.deployLatest(tracker.id));
                    })
                }) : null;
          var abortButton = Belt_Option.isNone(tracker.result) || tracker.requiresApproval && !tracker.resume && Belt_Option.mapWithDefault(tracker.result, false, Belt_Result.isOk) ? React.createElement(ButtonV2$MakerDs.make, {
                  text: "Abort",
                  variant: /* Secondary */1,
                  size: /* Xs */0,
                  outline: true,
                  onClickAsync: (function (param) {
                      return API_Result$MakerDs.Result.silentFailure(ClientAPI$FeedSync.killJob(tracker.id));
                    })
                }) : null;
          var match = tracker.result;
          var tmp;
          tmp = match !== undefined && match.TAG !== /* Ok */0 ? CSS$MakerDs.prefix("text-red-600") : "";
          return React.createElement("div", undefined, React.createElement("div", {
                          className: tmp
                        }, tracker.statusMessage), React.createElement("div", {
                          className: CSS$MakerDs.prefix("flex space-x-2")
                        }, viewButton, rollbackButton, deployButton, abortButton));
        }),
      getClassName: undefined,
      getColSpan: undefined
    }
  ];
  return React.createElement(Form$MakerDs.make, {
              title: "Sync History",
              description: "Realtime log of pending and past syncs.",
              children: null,
              footer: false
            }, settings.autoSync === /* Disabled */0 ? React.createElement(Alert$MakerDs.make, {
                    kind: /* Info */3,
                    padded: false,
                    children: "Auto-sync is off, you must manually sync, and approve the changes after reviewing them."
                  }) : null, settings.currencies.length !== 0 ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: CSS$MakerDs.prefix("flex space-x-4 items-center")
                      }, React.createElement(Button$MakerDs.make, {
                            onClickAsync: (function (param) {
                                return API_Result$MakerDs.Result.silentFailure(API_Result$MakerDs.Result.flatMapAsync(ClientAPI$FeedSync.ingest(undefined), (function (result) {
                                                  return API_Result$MakerDs.Result.map(API_Result$MakerDs.Result.make(Curry._2(mutate, (function (b) {
                                                                        return b;
                                                                      }), true)), (function (param) {
                                                                
                                                              }));
                                                })));
                              }),
                            outline: true,
                            text: "Sync Now"
                          }), React.createElement("div", {
                            className: CSS$MakerDs.prefix("text-xs text-gray-500")
                          }, "Import new products and update any that have changed.")), React.createElement(Table$MakerDs.make, {
                        dataSource: snapshots$1,
                        columns: columns,
                        fixed: true,
                        getRowClassName: getRowClassName
                      }), snapshots$1.length >= limit ? React.createElement(Button$MakerDs.make, {
                          onClick: (function (param) {
                              Location$FeedSync.goTo(undefined, undefined, undefined, undefined, ["monitoring"]);
                            }),
                          outline: true,
                          text: "See older"
                        }) : null) : React.createElement(Alert$MakerDs.make, {
                    kind: /* Info */3,
                    background: true,
                    border: true,
                    children: null
                  }, React.createElement("div", {
                        className: CSS$MakerDs.prefix("mb-2")
                      }, "Start by configuring yout feed on the Settings page."), React.createElement(Button$MakerDs.make, {
                        onClick: (function (param) {
                            Location$FeedSync.goTo(undefined, undefined, undefined, undefined, ["settings"]);
                          }),
                        outline: true,
                        text: "Go to Settings"
                      })));
}

var Show = {
  make: MonitoringPage$Show
};

function MonitoringPage(Props) {
  return React.createElement(Query$MakerDs.make, {
              hook: (function (param) {
                  return ClientAPI$FeedSync.useSettings(undefined);
                }),
              render: (function (settings, mutate) {
                  return React.createElement(Query$MakerDs.make, {
                              hook: (function (param) {
                                  return ClientAPI$FeedSync.useSnapshotHistory(undefined);
                                }),
                              render: (function (snapshots, mutate) {
                                  return React.createElement(Layout$FeedSync.make, {
                                              activeNavItem: /* MonitoringItem */1,
                                              children: React.createElement(MonitoringPage$Show, {
                                                    settings: settings,
                                                    snapshots: snapshots,
                                                    mutate: mutate
                                                  })
                                            });
                                }),
                              fallback: (function (err) {
                                  return React.createElement(ErrorPage$FeedSync.make, {
                                              err: err
                                            });
                                })
                            });
                }),
              fallback: (function (err) {
                  return React.createElement(ErrorPage$FeedSync.make, {
                              err: err
                            });
                })
            });
}

var make = MonitoringPage;

export {
  Show ,
  make ,
}
/* react Not a pure module */
